import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./Span.module.scss";

function Span({ children, className, types }) {
  const spanClasses = classnames(className, ...types.map(type => styles[type]));

  return <span className={spanClasses}>{children}</span>;
}

Span.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  types: PropTypes.arrayOf(PropTypes.string),
};

Span.defaultProps = {
  children: null,
  className: null,
  types: [],
};

Span.displayName = "Span";

export default Span;
